import React, { Component, PropTypes } from 'react';
import { StoreOverviewActions } from 'actions';
import { TagSelector } from 'components/Tags';
import { DropDown } from 'components/DropDown';
import StoreList from 'components/Store/StoreList';
import { getSearchedStoreItems } from 'selectors/store';

import { Units, Colors } from 'Css';

const css = oxygenCss({
  container: {
    position: 'relative',
    display: 'flex',
    padding: `${Units.base / 2}px ${Units.base * 3}px`,
    '@phone': {
      padding: `${Units.base / 2}px ${Units.base * 2}px`,
      flexDirection: 'column'
    }
  },
  half: {
    width: '50%',
    '@phone': {
      width: 'auto'
    }
  },
  searchBarContainer: {
    padding: `${Units.base / 2}px ${Units.base * 3}px`
  },
  searchBar: {
    // display: 'inline-block',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    borderRadius: 2.2,
    fontWeight: 100,
    border: 'solid 2px #EEE',
    padding: `0 ${Units.base / 2}px`,
    '&fullWidth': {
      display: 'block'
    },
    ' input': {
      height: 40,
      lineHeight: '40px',
      border: 'none',
      outline: 'none',
      background: 'transparent',
      display: 'inline-block',
      minWidth: Units.keyline * 2,
      padding: Units.base / 4,
      verticalAlign: 'top',
      textAlign: 'left',
      boxSizing: 'border-box',
      width: '100%',
      '::placeholder': {
        color: Colors.text.Dark.disabled
      }
    }
  },
  inputWrapper: {
    verticalAlign: 'middle',
    height: 40,
    lineHeight: '40px'
  }
});

class StoreFilter extends Component {
  static propTypes = {
    categories: PropTypes.array,
    filter: PropTypes.object
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  setCategory = (event, foo, category) => {
    const { categoryId } = category;
    StoreOverviewActions.setFilterCategory(categoryId);
  };

  addTag = tagName => {
    StoreOverviewActions.setFilterTag(tagName);
  };

  removeTag = tagName => {
    StoreOverviewActions.setFilterTag(tagName, false);
  };

  handleCategoryChange = categoryId => {
    StoreOverviewActions.setFilterCategory(categoryId);
  };

  handleSearchTextChagne = event => {
    const { value: searchText } = event.target;
    StoreOverviewActions.setSearchText(searchText);
  };

  render() {
    const { getIntlMessage } = this.context;
    const {
      themeColor,
      storeItems,
      categories,
      filter,
      items,
      store
    } = this.props;
    const { tags, categoryId, searchText } = filter;
    const menuItems = [
      { payload: null, label: getIntlMessage('store.chooseCategory') },
      ...categories.map(category => ({
        payload: category.slug,
        label: category.label
      }))
    ];
    const hasSearchText = searchText && searchText.trim() !== '';
    const placeholderText =
      typeof placeholder === 'undefined'
        ? getIntlMessage('Search')
        : placeholder;
    return (
      <div>
        <div className={css.searchBarContainer}>
          <div className={css.searchBar}>
            <div className={css.inputWrapper}>
              <input
                className={css.input}
                type="text"
                placeholder={placeholderText}
                onChange={this.handleSearchTextChagne}
              />
            </div>
          </div>
        </div>
        <div className={css.container}>
          <div className={css.half}>
            <div>Category</div>
            <DropDown
              fullWidth
              onChange={this.handleCategoryChange}
              options={menuItems}
              selected={categoryId}
            />
          </div>
          <div className={css.half}>
            <div>{getIntlMessage('Tags')}</div>
            <TagSelector
              fullWidth
              tags={tags}
              onAddTag={this.addTag}
              onRemoveTag={this.removeTag}
            />
          </div>
        </div>
        <StoreList
          onTouchTapItem={this.gotoItem}
          themeColor={themeColor}
          displayFilter={false}
          items={hasSearchText ? getSearchedStoreItems(storeItems, filter) : []}
          username={store}
        />
      </div>
    );
  }
}

export default StoreFilter;



// WEBPACK FOOTER //
// ./src/js/components/Store/StoreFilter.js